<script setup lang="ts">
import { DialogComponent as EjsDialog, type AnimationSettingsModel } from '@syncfusion/ej2-vue-popups';
import { computed } from 'vue';
import GLoader from '@/components/layout/GLoader.vue';
import { useLoadingStore } from '@/stores/loading';

const props = withDefaults(defineProps<{
    id: string;
    title?: string;
    size?: 'normal' | 'small' | 'bigger' | 'large',
    showCloseButton?: boolean;
    showHeader?: boolean;
    component: any;
    componentProps?: Record<string, any>;
    componentEvents?: Record<string, Function>;
}>(), ({
    size: 'normal',
    showCloseButton: true,
    showHeader: true
}));

const animationSettings: AnimationSettingsModel = { effect: 'Zoom' };
const loadingStore = useLoadingStore();

const width = computed(() => {
    switch (props.size) {
        case 'small':
            return '300px';
        case 'bigger':
            return '900px';
        case 'large':
            return '90vw';
        default:
            return '500px';
    }
});


const close = () => {
    props.componentEvents!.close();
}

</script>

<template>
    <ejs-dialog :header="showHeader ? 'headerTemplate' : undefined" :cssClass="showHeader ? '' : 'headerless'" :content="'contentTemplate'" :width="width" :isModal="true"
        :animationSettings='animationSettings' :close-on-escape="true" :before-close="close">
        <template v-slot:headerTemplate>
            <div class="header">
                <span>{{ title }}</span>
                <button v-if="showCloseButton" class="close" @click="close"> <i class="fas fa-times"></i></button>
            </div>
        </template>

        <template v-slot:contentTemplate>
            <div :class="{ blur: loadingStore.isLoading }">
                <component :is="component" v-bind="componentProps" v-on="componentEvents" />
                <GLoader></GLoader>
            </div>
        </template>
    </ejs-dialog>
</template>

<style lang="scss" scoped>
.headerless {
    :deep(.e-dlg-content) {
        padding: 0;
    }
}

:deep(.e-dlg-header) {
    width: 100%;

}

.header {
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: 16px;

    &>span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .close {
        background: none;
        border: none;
        font-size: 1.2rem;
        cursor: pointer;
    }
}
</style>